
// export default BreadcrumbTrail;
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const BreadcrumbTrail = ({ feature, onBack }) => {
  const [trail, setTrail] = useState([
    { name: "Home", code: "root", geo_level_code: 0 },
  ]);
  const navigate = useNavigate();

  useEffect(() => {
    if (feature?.location_info?.length) {
      setTrail([
        { name: "Home", code: "root", geo_level_code: 0 },
        ...feature.location_info.map((loc) => ({
          name: loc.name,
          code: loc.code,
          geo_level_code: loc.geo_level_code,
        })),
      ]);
    }
  }, [feature]);

  const handleClick = (item, idx) => {
    if (item.code === "root") {
      navigate("/"); // Explore → redirect
      return;
    }
    setTrail(trail.slice(0, idx + 1));
    onBack(item); // Pass {code, geo_level_code}
  };

  return (
    <ul className="breadcrumb">
      {trail.map((item, idx) => (
        <li
          key={idx}
          className={`breadcrumb-item ${idx === trail.length - 1 ? "active" : ""}`}
        >
          {idx === trail.length - 1 ? (
            <span>{item.name}</span>
          ) : (
            <span
              style={{ cursor: "pointer", color: "blue" }}
              onClick={() => handleClick(item, idx)}
            >
              {item.name}
            </span>
          )}
        </li>
      ))}
    </ul>
  );
};

export default BreadcrumbTrail;
